import React from 'react';
import { useAppSelector } from '../store/hooks';
import { selectModalOnboarding } from '../store/onboardingSlice';
import { selectBaseUrl, selectStageCheckList } from '../store/signedDateSlice';
import { GenericUpdateForm } from '../OnboardingViewModal';
import { Checklist } from './OnboardingViewHelpers';
import './SignedDateModal.css';

const SignedDateModal = () => {
  // Redux state
  const baseUrl = useAppSelector(selectBaseUrl);
  const stageCheckList = useAppSelector(selectStageCheckList);

  const modalOnboarding = useAppSelector(selectModalOnboarding);

  const signedDate = modalOnboarding?.signedDate;

  const formatDate = (dateString) => {
    if (!dateString) return 'Not set';
    return new Date(dateString).toLocaleDateString();
  };

  const DisplaySignedDate = () => {
    if (!signedDate) {
      return (
        <div>
          <p className="signed-date-error">Deal has not been signed</p>
        </div>
      )
    }
    return (
              <div>
          <p className="signed-date-display">{formatDate(signedDate)}</p>
        </div>
    )
  }
  

  return (
    <div className="space-y-4">
      { modalOnboarding && (
        <div>
          <DisplaySignedDate />
          <GenericUpdateForm onboarding={modalOnboarding} stage="signedDate" baseUrl={baseUrl} />
          
          {/* Checklist Component */}
          <Checklist 
            stage="signedDate" 
            onboarding={modalOnboarding} 
            stateCheckList={stageCheckList} 
          />
        </div>
      )}
    </div>
  );
};

export const displayHistorySignedDate = (onboarding) => {
  // For now, return a simple table row with placeholder data
  // In the future, this would parse actual history data from the onboarding object
  return (
    <tr className="signed-date-history-row">
      <td className="signed-date-history-cell">
        {new Date().toLocaleString()}
      </td>
      <td className="signed-date-history-cell">
        Not set
      </td>
      <td className="signed-date-history-cell">
        {onboarding.signedDate ? new Date(onboarding.signedDate).toLocaleDateString() : 'Not set'}
      </td>
      <td className="signed-date-history-cell">
        Initial status
      </td>
    </tr>
  );
};

export { SignedDateModal };
